/* eslint-disable max-lines */
import { vehicleInfo } from 'api';
import {
  GET_DRIVER,
  GET_VEHICLE,
  GET_INTERVENTIONS,
  GET_INTERVENTIONS_HISTORIC,
  GET_NOTIFICATIONS,
  SEND_NOTIFICATION_READED,
  GET_INFO_USER,
  SET_INFO_USER,
  GET_TOWNS_BY_CP,
  UPDATE_TOWNS_BY_CP_CACHE,
  UPDATE_DRIVER_INFO,
  VALIDATE_DOCUMENT,
  GET_DOCUMENTS,
  SEND_MAIL_CONTACT_US,
  GET_OPERATIONS_CARD_FUEL,
  RESET_INTERVENTIONS,
  UPDATE_KMS_OPERATION,
  GET_DRIVER_AVATAR,
  SEND_DRIVER_AVATAR,
  GET_INCIDENT_BY_PROVINCE,
  OFFER_LEGAL_CONDITIONS,
  APPLIED_CONSENTS,
  GET_AUTOLOGIN,
  SET_VEHICLE_SELECTED,
  GET_TYPES_INCIDENTS,
  GET_LEVEL_2,
  GET_LEVEL_3,
  CREATE_CRM_WEB_CONDUCTORES,
  AUTHORIZATION_VEHICLE_SER_CARD,
  AUTHORIZATION_DEPOSIT_EXIT,
  AUTHORIZATION_ACCESORIES_ASSEMBLY,
  FOREIGN_NATIONAL,
  GET_REMPLACEMENT_VEHICLE_COVERAGE,
  REMPLACEMENT_VEHICLE_PROCESS_REQUEST,
  GET_TOWNS_BY_PROVINCE_CODE,
  UPDATE_TOWNS_BY_PROVINCE_CODE_CACHE
} from 'store/actions/vehicleInfo';
import { UI_SET_LOADER } from 'store/actions/ui';
import { lsRemoveDriver, lsSetDriver, lsGetDriver } from 'helpers/store';
import { encryptIdentifier } from 'helpers/encrypt';
import { mapArraryMasterDataContactSelect } from 'helpers/object';

export default {
  // Validate the token and update it with new API data if it is not valid
  [GET_DRIVER]: ({ commit, dispatch, getters, state }, driverId) =>
    new Promise((resolve, reject) => {
      const firstLogin = getters.data('firstLogin');
      const lsDriver = lsGetDriver();

      dispatch(`ui/${UI_SET_LOADER}`, true, { root: true });

      if (firstLogin || !lsDriver) {
        lsRemoveDriver();
        const driverIdEncrypted = encryptIdentifier(driverId);
        vehicleInfo.getDriver(driverIdEncrypted).then(
          resp => {
            const data = resp.data;
            const { enrollments } = data;
            commit(GET_DRIVER, data);
            commit(SET_INFO_USER, {
              field: 'driverId',
              value: driverId
            });
            commit(SET_INFO_USER, { field: 'firstLogin', value: false });

            dispatch(GET_DRIVER_AVATAR, driverId);

            if (enrollments?.length) {
              commit(SET_INFO_USER, {
                field: 'carPlateSelect',
                value: enrollments[0].trim()
              });
              dispatch(GET_VEHICLE, { carPlateData: enrollments, driverId });
            } else {
              dispatch(`ui/${UI_SET_LOADER}`, false, { root: true });
            }
            lsSetDriver(data);
            resolve(data);
          },
          err => {
            dispatch(`ui/${UI_SET_LOADER}`, false, { root: true });
            commit(GET_DRIVER, err);
            reject();
          }
        );
      } else {
        if (state.carPlateSelect && state.driverId) {
          // TODO:  dispatch(GET_NOTIFICATIONS); Deshabilitado hasta proximo aviso
          Promise.all([dispatch(GET_INTERVENTIONS)]).finally(() => {
            dispatch(`ui/${UI_SET_LOADER}`, false, {
              root: true
            });
          });
        } else {
          dispatch(`ui/${UI_SET_LOADER}`, false, { root: true });
        }
        resolve(lsDriver);
      }
    }),

  [GET_VEHICLE]: ({ dispatch, commit, state, rootState }, { carPlateData, driverId }) =>
    new Promise((resolve, reject) => {
      dispatch(`ui/${UI_SET_LOADER}`, true, { root: true });

      const driverIdEncrypted = encryptIdentifier(driverId);
      const promises = carPlateData.map(carPlate => {
        const carPlateEncrypted = encryptIdentifier(carPlate);
        return vehicleInfo.getVehicle(carPlateEncrypted, driverIdEncrypted);
      });

      Promise.all(promises)
        .then(responses => {
          responses.forEach(resp => {
            const data = resp.data;
            const elementBrand = rootState.ui.brands.find(
              element => element.name.toUpperCase() === data.brand.toUpperCase()
            );
            data.logo = elementBrand?.logoURL;

            commit(GET_VEHICLE, { data });

            if (data.enrollment === state.carPlateSelect) {
              commit(SET_VEHICLE_SELECTED, {
                vehicleSelected: data
              });
            }
          });
          // TODO:  dispatch(GET_NOTIFICATIONS); Deshabilitado hasta proximo aviso
          return Promise.all([dispatch(GET_INTERVENTIONS)]);
        })
        .then(() => {
          resolve();
        })
        .catch(err => {
          commit(GET_VEHICLE, err);
          reject(err);
        })
        .finally(() => {
          dispatch(`ui/${UI_SET_LOADER}`, false, { root: true });
        });
    }),

  [GET_INTERVENTIONS]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      const carPlate = state.carPlateSelect;
      const carPlateEncrypted = encryptIdentifier(carPlate);
      vehicleInfo.getInterventions(carPlateEncrypted).then(
        resp => {
          const data = resp.data;
          commit(GET_INTERVENTIONS, data);
          resolve();
        },
        err => {
          commit(GET_INTERVENTIONS, err);
          reject();
        }
      );
    }),

  [GET_NOTIFICATIONS]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      const carPlate = state.carPlateSelect;
      const driverId = state.driverId;
      const driverIdEncrypted = encryptIdentifier(driverId);
      const carPlateEncrypted = encryptIdentifier(carPlate);
      vehicleInfo.getNotifications(driverIdEncrypted, carPlateEncrypted).then(
        resp => {
          const data = resp.data;
          commit(GET_NOTIFICATIONS, data);
          resolve();
        },
        err => {
          commit(GET_NOTIFICATIONS, err);
          reject();
        }
      );
    }),

  [SEND_NOTIFICATION_READED]: ({ state, commit }, { notificationId }) =>
    new Promise((resolve, reject) => {
      const driverIdEncrypted = encryptIdentifier(state.driverId);
      const notificationIdEncrypted = encryptIdentifier(notificationId);
      vehicleInfo.sendReadedNotification(driverIdEncrypted, notificationIdEncrypted).then(
        () => {
          commit(SEND_NOTIFICATION_READED, notificationId);
          resolve();
        },
        () => {
          reject();
        }
      );
    }),

  [GET_INTERVENTIONS_HISTORIC]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      const carPlate = state.carPlateSelect;
      const carPlateEncrypted = encryptIdentifier(carPlate);
      vehicleInfo.getInterventionsHistoric(carPlateEncrypted).then(
        resp => {
          const data = resp.data;
          commit(GET_INTERVENTIONS_HISTORIC, data);
          resolve();
        },
        err => {
          commit(GET_INTERVENTIONS_HISTORIC, err);
          reject();
        }
      );
    }),

  [GET_INFO_USER]: ({ commit }, UserId) =>
    new Promise((resolve, reject) => {
      vehicleInfo.getInfoUser(UserId).then(
        resp => {
          const data = resp.data;
          if (data.documents) {
            data.documentsUploaded = data.documents.reduce(
              (h, { documentType, documentURL }) =>
                Object.assign(h, {
                  [documentType]: (h[documentType] || []).concat({ documentURL })
                }),
              {}
            );
          }
          commit(GET_INFO_USER, data);
          resolve();
        },
        err => {
          commit(GET_INFO_USER, err);
          reject();
        }
      );
    }),

  [GET_TOWNS_BY_CP]: ({ state, commit }, cp) =>
    new Promise((resolve, reject) => {
      const townsCache = state.townsCache;
      const townsByCpCache = townsCache[cp];
      if (townsByCpCache !== undefined && townsByCpCache.length > 0) {
        return resolve(townsByCpCache);
      }
      vehicleInfo.getTownsByCp(cp).then(
        resp => {
          const towns = resp.data;
          commit(UPDATE_TOWNS_BY_CP_CACHE, {
            cp,
            towns
          });
          resolve(towns);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [GET_TOWNS_BY_PROVINCE_CODE]: ({ state, commit }, provinceCode) =>
    new Promise((resolve, reject) => {
      const townsCache = state.townsProvinceCodeCache;
      const townsByCpCache = townsCache[provinceCode];
      if (townsByCpCache !== undefined && townsByCpCache.length > 0) {
        return resolve(townsByCpCache);
      }
      vehicleInfo.getTownsByProvinceCode(provinceCode).then(
        resp => {
          const towns = resp.data;
          commit(UPDATE_TOWNS_BY_PROVINCE_CODE_CACHE, { provinceCode, towns });
          resolve(towns);
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [UPDATE_DRIVER_INFO]: (_, infoUser) =>
    new Promise((resolve, reject) => {
      vehicleInfo.updateDriverInfo(infoUser).then(
        () => {
          resolve();
        },
        () => {
          reject();
        }
      );
    }),

  [SET_INFO_USER]: ({ commit }, { field, value }) => commit(SET_INFO_USER, { field, value }),

  [RESET_INTERVENTIONS]: ({ commit }) => commit(RESET_INTERVENTIONS),

  [VALIDATE_DOCUMENT]: (params, data) =>
    new Promise((resolve, reject) => {
      vehicleInfo.validateDocument(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [GET_DOCUMENTS]: (params, data) =>
    new Promise((resolve, reject) => {
      vehicleInfo.getDocuments(data).then(
        resp => {
          resolve(resp.data);
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [SEND_MAIL_CONTACT_US]: ({ state }, data) =>
    new Promise((resolve, reject) => {
      const driverIdEncrypted = encryptIdentifier(state.driverId);
      const carPlateEncrypted = encryptIdentifier(state.carPlateSelect);
      vehicleInfo.sendMailContactUs(driverIdEncrypted, carPlateEncrypted, data).then(
        resp => {
          resolve(resp);
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [GET_OPERATIONS_CARD_FUEL]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      const carPlate = state.carPlateSelect;
      const carPlateEncrypted = encryptIdentifier(carPlate);
      vehicleInfo.getOperations(carPlateEncrypted).then(
        resp => {
          const data = resp.data;
          commit(GET_OPERATIONS_CARD_FUEL, data);
          resolve(data);
        },
        err => {
          commit(GET_OPERATIONS_CARD_FUEL, err);
          reject(err);
        }
      );
    }),

  [UPDATE_KMS_OPERATION]: ({ commit }, { kms, operationId }) =>
    new Promise((resolve, reject) => {
      const operationIdEncrypted = encryptIdentifier(operationId);
      vehicleInfo.updateKmsOperation(operationIdEncrypted, kms).then(
        () => resolve(),
        err => {
          commit(UPDATE_KMS_OPERATION, err);
          reject();
        }
      );
    }),

  [GET_DRIVER_AVATAR]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      const driverIdEncrypted = encryptIdentifier(state.driverId);
      vehicleInfo.getDriverAvatar(driverIdEncrypted).then(
        resp => {
          const data = resp.data;
          commit(SET_INFO_USER, { field: 'driverAvatar', value: data });
          resolve(data);
        },
        err => {
          commit(GET_DRIVER_AVATAR, err);
          reject(err);
        }
      );
    }),

  [SEND_DRIVER_AVATAR]: ({ state, commit }, data) =>
    new Promise((resolve, reject) => {
      const driverIdEncrypted = encryptIdentifier(state.driverId);
      vehicleInfo.sendDriverAvatar(driverIdEncrypted, data).then(
        resp => {
          commit(SET_INFO_USER, { field: 'driverAvatar', value: data });
          resolve(resp.data);
        },
        err => {
          commit(SEND_DRIVER_AVATAR, err);
          reject(err);
        }
      );
    }),

  [GET_INCIDENT_BY_PROVINCE]: ({ commit }, { provinceId }) =>
    new Promise((resolve, reject) => {
      const provinceIdEncrypted = encryptIdentifier(provinceId);
      vehicleInfo.getIncidentsDgt(provinceIdEncrypted).then(
        resp => {
          const data = resp.data;
          resolve(data);
        },
        err => {
          commit(GET_INCIDENT_BY_PROVINCE, err);
          reject(err);
        }
      );
    }),

  [GET_AUTOLOGIN]: ({ commit }, encryptData) =>
    new Promise((resolve, reject) => {
      vehicleInfo.getAutologin(encryptData).then(
        resp => {
          const data = resp.data;
          commit(GET_AUTOLOGIN, data);
          resolve(data);
        },
        err => {
          commit(GET_AUTOLOGIN, err);
          reject(err);
        }
      );
    }),

  [OFFER_LEGAL_CONDITIONS]: ({ commit }, step) =>
    new Promise((resolve, reject) => {
      vehicleInfo.legalConditionsData(step).then(
        resp => {
          commit(OFFER_LEGAL_CONDITIONS, resp.data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),
  [APPLIED_CONSENTS]: (params, { driverId, consents }) =>
    new Promise((resolve, reject) => {
      const driverIdEncrypted = encryptIdentifier(driverId);
      vehicleInfo.appliedConsents(driverIdEncrypted, consents).then(
        () => {
          resolve();
        },
        () => {
          reject();
        }
      );
    }),
  [GET_TYPES_INCIDENTS]: ({ commit }) =>
    new Promise((resolve, reject) => {
      vehicleInfo.getTypesIncidents().then(
        resp => {
          const data = resp.data;
          const typesIncidents = mapArraryMasterDataContactSelect(data);
          commit(SET_INFO_USER, { field: 'typesIncidents', value: typesIncidents });
          resolve();
        },
        () => {
          reject();
        }
      );
    }),
  [GET_LEVEL_2]: ({ commit }, value) =>
    new Promise((resolve, reject) => {
      vehicleInfo.getLevel2(value).then(
        resp => {
          const data = resp.data;
          const level2 = mapArraryMasterDataContactSelect(data);
          commit(SET_INFO_USER, { field: 'level2', value: level2 });
          resolve();
        },
        () => {
          reject();
        }
      );
    }),
  [GET_LEVEL_3]: ({ commit }, { typesIncidents, level2 }) =>
    new Promise((resolve, reject) => {
      vehicleInfo.getLevel3(typesIncidents, level2).then(
        resp => {
          const data = resp.data;
          const level3 = mapArraryMasterDataContactSelect(data);
          commit(SET_INFO_USER, { field: 'level3', value: level3 });
          resolve();
        },
        () => {
          reject();
        }
      );
    }),
  [CREATE_CRM_WEB_CONDUCTORES]: (params, message) =>
    new Promise((resolve, reject) => {
      vehicleInfo.createCRMWebConductores(message).then(
        resp => {
          resolve(resp);
        },
        err => {
          reject(err.response);
        }
      );
    }),
  [AUTHORIZATION_VEHICLE_SER_CARD]: (params, data) =>
    new Promise((resolve, reject) => {
      vehicleInfo
        .authorizationVehicleSerCard(data)
        .then(resp => {
          const response = resp;
          resolve(response);
        })
        .catch(err => {
          reject(err.response);
        });
    }),
  [GET_REMPLACEMENT_VEHICLE_COVERAGE]: (params, plateNumber) =>
    new Promise((resolve, reject) => {
      vehicleInfo
        .replacementVehicleCoverage(plateNumber)
        .then(resp => {
          const data = resp.data;
          resolve(data);
        })
        .catch(err => {
          reject(err.response);
        });
    }),
  [AUTHORIZATION_DEPOSIT_EXIT]: (params, data) =>
    new Promise((resolve, reject) => {
      vehicleInfo
        .authorizationDepositExit(data)
        .then(resp => {
          const response = resp;
          resolve(response);
        })
        .catch(err => {
          reject(err.response);
        });
    }),
  [AUTHORIZATION_ACCESORIES_ASSEMBLY]: (params, data) =>
    new Promise((resolve, reject) => {
      vehicleInfo
        .authorizationAccessoriesAssembly(data)
        .then(resp => {
          const response = resp;
          resolve(response);
        })
        .catch(err => {
          reject(err.response);
        });
    }),
  [FOREIGN_NATIONAL]: (params, data) =>
    new Promise((resolve, reject) => {
      vehicleInfo
        .foreignNational(data)
        .then(resp => {
          const response = resp;
          resolve(response);
        })
        .catch(err => {
          reject(err.response);
        });
    }),
  [REMPLACEMENT_VEHICLE_PROCESS_REQUEST]: (params, data) =>
    new Promise((resolve, reject) => {
      vehicleInfo
        .replacementVehicleProcessRequest(data)
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    })
};
